import React, { useEffect, useState } from 'react';
import { Checkbox, Grid, makeStyles } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import moment from 'moment';
import axiosInstance, { EVENT_ID, WEB_API } from '../constatns';

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: 800,
    overflow: 'auto',
    '& .MuiPaper-root': {
      boxShadow: 'none',
      border: '1px solid rgba(224, 224, 224, 1)',
    },
    '& .MuiTableCell-root': {
      textAlign: 'center',
      fontSize: '13px',
      '& span': {
        display: 'block',
        wordBreak: 'keep-all',
      },
      '& button': {
        fontSize: '13px',
      },
    },
    '& .MuiToolbar-root': {
      // marginTop: '-40px',
    },
  },
  link: {
    cursor: 'pointer',
    textDecoration: 'underline',
    '&:hover': {
      color: theme.palette.secondary.main,
    },
  },
}));

const PaperReviewJudge = (props) => {
  const { history } = props;
  const classes = useStyles();
  const [data, setData] = useState();

  let cols = [
    {
      name: 'id',
      label: 'No',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
        download: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return tableMeta.tableData.length - tableMeta.rowIndex;
        },
      },
    },
    {
      name: 'memNo',
      label: 'RegNum',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
      },
    },
    {
      name: 'in_name_en',
      label: 'Name(Kor)',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div>
              {value}
              <div>{'(' + tableMeta.tableData[tableMeta.rowIndex].username + ')'}</div>
            </div>
          );
        },
      },
    },
    {
      name: 'email',
      label: 'ID(E-mail)',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
      },
    },
    {
      name: 'positionEn',
      label: '소속 / Affiliation',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div>
              {value}
              <div>{'(' + tableMeta.tableData[tableMeta.rowIndex].position + ')'}</div>
            </div>
          );
        },
      },
    },
    {
      name: 'isReviewer',
      label: '등록',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Checkbox
              checked={value || false}
              onChange={(e) => {
                handleAdmin(e, tableMeta);
                updateValue(e.target.checked);
              }}
            />
          );
        },
      },
    },
  ];

  const handleAdmin = (e, meta) => {
    const updateParam = {
      evt: EVENT_ID,
      userId: data[meta.rowIndex].id,
      isReviewer: e.target.checked,
    };
    axiosInstance.put(`${WEB_API}/user/`, updateParam).then((data) => {});
  };

  const options = {
    print: false,
    searchOpen: true,
    filter: false,
    download: false,
    viewColumns: false,
    selectableRows: 'none',
    downloadOptions: {
      filename: `Abstract_Review_${moment().valueOf()}.csv`,
    },
    customSearch: (searchQuery, currentRow, columns) => {
      let isFound = false;
      data.map((member) => {
        if (member.id === currentRow[0]) {
          for (const [key, value] of Object.entries(member)) {
            if (typeof value === 'string') {
              if (value.indexOf(searchQuery) !== -1) isFound = true;
            }
          }
        }
      });
      return isFound;
    },
  };

  const getMemberData = () => {
    // axiosInstance.get(`${WEB_API}/user/list?eventId=${getEventId()}&limit=-1`, { headers: { Pragma: 'no-cache' } }).then((response) => {
    //   const arrData = response.data.Items.sort((a, b) => {
    //     return Number(b.createdAt) - Number(a.createdAt);
    //   });
    //   setData(arrData);
    //   setAllData(arrData);
    // });
    setData(props.infoData);
  };

  useEffect(() => {
    getMemberData();
  }, []);

  return (
    <Grid item xs={12}>
      <Grid container alignItems={'stretch'} direction="column" style={{ padding: 16 }} className={classes.root}>
        <Grid item>
          <Grid container spacing={4} justifyContent={'flex-start'} alignItems={'center'}>
            <Grid item>
              <h1>심사워원 등록</h1>
            </Grid>
          </Grid>
        </Grid>
        <Grid item style={{ marginTop: 20 }}>
          <MUIDataTable title={''} data={data} columns={cols} options={options} />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default PaperReviewJudge;
